import { Filter, useGetList } from 'react-admin';
import { useMemo } from 'react';
import { AutocompleteInput } from 'react-admin';
import { translate } from '../../i18n/customI18nProvider';

const EventFilter = ({ alwaysOn }) => {
    const { data } = useGetList('events', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'name', order: 'ASC' },
    });

    const choices = useMemo(() => {
        const events = data ? Object.values(data) : [];

        return [
            { id: '__none__', name: translate('custom.no_event') },
            { id: '__all__', name: translate('custom.all_events') },
            ...events,
        ];
    }, [data]);

    return (
        <div>
            <AutocompleteInput
                variant="outlined"
                source="event_id"
                choices={choices}
                optionText="name"
                optionValue="id"
                label="Événement"
                alwaysOn={alwaysOn}
                helperText={false}
            />
        </div>
    );
};

export default EventFilter;